import { Action } from '@ngrx/store';
import { FeatureFlag } from './feature-flag';

export enum FeatureFlagsActionTypes {
  SetFeatures = '[FeatureFlags] Set Features',
}

export class SetFeatures implements Action {
  public readonly type = FeatureFlagsActionTypes.SetFeatures;

  constructor(public features: FeatureFlag[]) {}
}
